import { render, staticRenderFns } from "./turntableActivities.vue?vue&type=template&id=3dc95fd8&scoped=true"
import script from "./turntableActivities.vue?vue&type=script&lang=js"
export * from "./turntableActivities.vue?vue&type=script&lang=js"
import style0 from "./turntableActivities.vue?vue&type=style&index=0&id=3dc95fd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc95fd8",
  null
  
)

export default component.exports